import { TextBox } from '@apply/components';
import { usePaymentStore } from '../../../../../state/paymentStore';

export const City: React.FC = () => {
    const city = usePaymentStore((s) => s.city);
    const set_city = usePaymentStore((s) => s.set_city);

    return (
        <TextBox
            value={city}
            onChange={(value) => set_city(value)}
            label='City'
            required={true}
        />
    );
};
